import React from "react";
import { useTranslation } from "react-i18next";
import { Role } from "../../../types/modules/admin/role.type";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  roles: Role[];
}

const RolesListTable: React.FC<Props> = ({ roles }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("role_name")}</th>
            <th className="p-3 font-normal capitalize">{t("employees_count")}</th>
            <th className="p-3 font-normal capitalize">{t("permissions_count")}</th>
            <th className="p-3 font-normal capitalize">{t("details")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateRole]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {roles.map((role, index) => (
            <tr
              key={role.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                    {role.id}
                </td>
                <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                    {role.name}
                </td>
                <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                    {role.adminCount}
                </td>
                <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                    {role.permissionCount===0 ?"----" : role.permissionCount}
                </td>
                <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                    <Link to={`/admin/roles/${role.id}`} className=" underline">
                    {t("view")}
                    </Link>
                </td>
                <PermissionGate permissions={[PermissionsKey.UpdateRole]}>
                  <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                    <Link to={`/admin/roles/${role.id}/update`}>
                        <Pencil size={20}/>
                    </Link>
                </td>
                </PermissionGate>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default RolesListTable;